import { useCallback, useState } from "react"
import { apiFetch } from "../../../utils/apiFetch"


const patientNameCollator = new Intl.Collator("es-MX", {
  sensitivity: "base",
  numeric: true,
  ignorePunctuation: true
})

function getPatientSortName(patient) {
  return `${patient?.firstName || ""} ${patient?.lastName || ""}`.trim()
}

const API_BASE = (() => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname
    const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1"

    return isLocalHost ? (["http://localhost", "3000/api"].join(":")) : "/api"
  }

  return "/api"
})()

export default function usePatientsListLoader({ resolveSafeClinicId }) {
  const [patients, setPatients] = useState([])
  const [loadingPatients, setLoadingPatients] = useState(false)
  const [loadedPatientsClinicId, setLoadedPatientsClinicId] = useState("")

  const loadPatients = useCallback(
    async (searchText = "") => {
      try {
        const currentClinicId = resolveSafeClinicId()

        if (!currentClinicId) {
          setPatients([])
          setLoadedPatientsClinicId("")
          return
        }

        setLoadingPatients(true)
        setLoadedPatientsClinicId("")

        const params = new URLSearchParams({
          clinicId: currentClinicId,
          q: searchText || "",
          limit: "50"
        })

        const res = await apiFetch(
          `${API_BASE}/appointments/clinic-patients?${params.toString()}`
        )

        const data = await res.json().catch(() => [])
        const rows = Array.isArray(data) ? data : []
        const sortedRows = [...rows].sort((a, b) =>
          patientNameCollator.compare(getPatientSortName(a), getPatientSortName(b))
        )

        if (res.ok) {
          setPatients(sortedRows)
          setLoadedPatientsClinicId(currentClinicId)
        } else {
          setPatients([])
          setLoadedPatientsClinicId("")
        }
      } catch {
        setPatients([])
        setLoadedPatientsClinicId("")
      } finally {
        setLoadingPatients(false)
      }
    },
    [resolveSafeClinicId]
  )

  return {
    patients,
    loadingPatients,
    loadedPatientsClinicId,
    loadPatients
  }
}
